import { createFileRoute } from '@tanstack/react-router'
import { HomeContent } from '@/features/home/components/HomeContent'
import { buildHomeHead } from '@/lib/seo/homeHead'
import { enumsQueryOptions } from '@/api/accommodation/hooks'

export const Route = createFileRoute('/')({
  component: HomePage,
  // The search filters' region and accommodation-type options come from enums.
  loader: ({ context }) => context.queryClient.query(enumsQueryOptions()).catch(() => undefined),
  head: () => buildHomeHead(),
})

function HomePage() {
  return <HomeContent />
}
